<script>
import FormElements from "@wielink-application/shared/js/mixins/formElements";
import Changes from "@wielink-application/shared/js/mixins/changes";
import {Link, useForm} from "@inertiajs/vue3";
import Card from "@/pages/components/card.vue";

export default {
  components: {Link, Card},
  mixins: [FormElements, Changes],
  data() {
    return {
      partId: '',

      form: useForm({
        king_code: '',
        name: '',
        price: 0,
      })
    }
  },
  methods: {
    setPart(part) {
      this.partId = part.id;
      this.form.defaults(Helpers.prepareFormDefaults(part));
      this.form.reset();
      this.form.isDirty = false;
    },
  }
}
</script>

<template>
  <div class="row g-4">
    <div class="col-xl-6">
      <Card class="h-100">
        <h2 class="card-title">Details</h2>

        <Input
            :form="form"
            v-model="form.king_code"
            name="king_code"
            :required="true"
            label="Artikelnummer King"
        />

        <Input
            :form="form"
            v-model="form.name"
            name="name"
            :required="true"
            label="Omschrijving"
        />

        <Price
            groupClasses="mb-0"
            :form="form"
            v-model="form.price"
            name="price"
            :required="true"
            label="Prijs"
        />
      </Card>
    </div>
  </div>

</template>